/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Live_BodyInputs */

const en_features_live_body = /** @type {(inputs: Features_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach writes the workout on their side and every exercise shows up on your phone the moment it is typed. Each set you log appears on their screen straight away.`)
};

const pl_features_live_body = /** @type {(inputs: Features_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener rozpisuje trening u siebie, a Ty widzisz każde ćwiczenie w telefonie, gdy tylko je wpisze. Serie, które zaliczasz, od razu widzi na swoim ekranie.`)
};

/**
* | output |
* | --- |
* | "Your coach writes the workout on their side and every exercise shows up on your phone the moment it is typed. Each set you log appears on their screen straig..." |
*
* @param {Features_Live_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_live_body = /** @type {((inputs?: Features_Live_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Live_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_live_body(inputs)
	return en_features_live_body(inputs)
});